import { upsertBy } from '@salescore/buff-common'
import type { ViewConfigField, ViewConfigMeasure } from '@salescore/core'

import { useSetFieldMutation } from '../../recoil/viewConfig'

export const useAddMeasureMutation = (setHasChangeToViewSchema: (hasChangeToViewSchema: boolean) => void) => {
  const setField = useSetFieldMutation()
  return ({ field, measure }: { field: ViewConfigField; measure: ViewConfigMeasure }): void => {
    const newField: ViewConfigField = {
      ...field,
      measures: upsertBy(field.measures ?? [], measure, (x) => x.name),
    }
    setField({
      field: newField,
      onSetConfig: () => {
        setHasChangeToViewSchema(true)
      },
    })
  }
}
